import { useParams } from 'react-router-dom'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { FormElement, FormRender } from '../../../../../../../forms/FormRenderer/types'
import { valueOrDefaultValue } from '../../../../../../../utils/globals/valueOrDefaultValue'
import { LittleModalCreateEdit } from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { BillingGroupPayload } from '../../../../../../../utils/reducers/company/billingGroups'
import { AllReduxPayloads } from '../../../../../../../utils/reducers'
import { ConnectedProps, connect } from 'react-redux'
import withLoading from '../../../../../../../utils/hoc/withLoading'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import { BillingTypeSellModelType } from '@teinor/erp/types/company/config/billingGroup/billingTypeSell'



type ModalCEConfigBillingTypeSellProps = ModalEditComponentProps & ReduxModalCEConfigBillingTypeSellConnector & {}

const ModalCEConfigBillingTypeSell: React.FC<ModalCEConfigBillingTypeSellProps> = ({ allRowData, userPermissions, billingGroups, ...rest }) => {
    const { t } = useTwinTranslation()
    const { BillingGroupId } = useParams()
    const byDefault: FormElement<keyof BillingTypeSellModelType>[] = []
    if (BillingGroupId && allRowData) {
        const billingTypesSell = billingGroups?.dictionaryBillingGroup?.[parseInt(BillingGroupId)]?.billingTypesSellDict || {}
        const billingTypeSell = billingTypesSell[allRowData.id]
        byDefault.push(
            {
                name: 'DefaultBillingTypeSellOptionId',
                label: t('byDefault', 'Por defecto'),
                component: 'CustomSelect',
                items: billingTypeSell?.billingTypeSellOptionsDict || {},
                value: allRowData['DefaultBillingTypeSellOptionId']
            }
        )
        byDefault.push(
            {
                name: 'DefaultBillingTypeSimpleSellOptionId',
                label: t('byDefaultSimpleInvoice', 'Por defecto factura simp.'),
                component: 'CustomSelect',
                items: billingTypeSell?.billingTypeSellOptionsDict || {},
                value: allRowData['DefaultBillingTypeSimpleSellOptionId']
            }
        )
    }
    const fields: FormRender<BillingTypeSellModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                },
                {
                    name: 'mandatory',
                    label: t('mandatory', 'Obligatorio'),
                    component: 'CheckboxMargin',
                },

                {
                    name: 'id',
                    component: 'InputHidden'
                },
                {
                    name: 'BillingGroupId',
                    component: 'InputHidden',
                    value: BillingGroupId
                },
                ...byDefault
            ]
        },
    ]

    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (<LittleModalCreateEdit fields={parsedFields} url={'/api/app/config/billingGroup/billingTypeSell/updateBillingTypeSell'} translations={{ title: t('editBillingTypeSell', 'Editar Tipo de facturación Venta'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} />)
    }
    return (<LittleModalCreateEdit fields={fields} url={'/api/app/config/billingGroup/billingTypeSell/createBillingTypeSell'} translations={{
        title: t('createBillingTypeSell', 'Crear Tipo de Facturación Venta'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}

const modalCEConfigBillingTypeSellDispatch = {
    setBillingGroups: (payload: BillingGroupPayload) => ({ type: 'CHANGE_BILLINGGROUP', payload }),
}
const mapModalCEConfigBillingTypeSellConnector = (state: AllReduxPayloads) => ({ billingGroups: state.billingGroups })
const modalCEConfigBillingTypeSellConnector = connect(mapModalCEConfigBillingTypeSellConnector, modalCEConfigBillingTypeSellDispatch)
type ReduxModalCEConfigBillingTypeSellConnector = ConnectedProps<typeof modalCEConfigBillingTypeSellConnector>

const modalCEConfigBillingTypeSellConnectLoading = withLoading(ModalCEConfigBillingTypeSell, [{ fetchUrl: '/api/app/config/billingGroup/getAllBillingGroupsComplete', propName: 'billingGroups', setFunctionName: 'setBillingGroups' }])
const ModalCEConfigBillingTypeSellConnect = modalCEConfigBillingTypeSellConnector(modalCEConfigBillingTypeSellConnectLoading)

export default ModalCEConfigBillingTypeSellConnect